import styles from "./wiggle.module.css";
import { Canvas } from "@react-three/fiber";
import { MeshWobbleMaterial } from "@react-three/drei";
import { motion } from "framer-motion-3d";

const Wiggle = () => {
  return (
    <div className={styles.canvas}>
      <Canvas>
        <ambientLight intensity={10} />
        <motion.mesh
          initial={{ scale: 0, y: -10 }}
          animate={{ scale: 1, y: -1 }}
          transition={{ duration: 3 }}
          position-y={-1}
        >
          <planeGeometry args={[13.6, 8, 50, 50]} />
          <MeshWobbleMaterial color="white" factor={0.02} speed={1} />
        </motion.mesh>
      </Canvas>
    </div>
  );
};

export default Wiggle;
